import { Reducer } from 'redux';
import {
  ActionTypes,
LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE,
RESET_PLAN_STATE, LOGOUT
} from '../actions/auth.actions';


export interface User {
  uuid: string;
  name: string;
  
}

export interface State {
  token: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  token:null,
  loading: false,
  error: null,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return { ...state, loading: true };
    case LOGIN_SUCCESS:
      const user = action.user;
      delete user.password;
      localStorage.setItem('access_token', action.payload);
      localStorage.setItem('user', JSON.stringify(user));   
      return { ...state, loading: false , token: action.payload, error: null };
    case LOGIN_FAILURE:
      return { ...state, loading: false , error: action.payload };
    case RESET_PLAN_STATE:
      return { ...state, loading: false , error: null };
    case LOGOUT:
      localStorage.clear();
      return { ...state, token:null}
    default:
      return state;
  }
};

export default reducer;
